import { useId, useState } from "react";
import { portfolioProfile } from "../content/portfolio";

type CopyState = "idle" | "copied" | "error";

export function ContactActions() {
  const statusId = useId();
  const [copyState, setCopyState] = useState<CopyState>("idle");
  const [status, setStatus] = useState("");
  const { email, mailtoSubject } = portfolioProfile.contact;
  const mailtoHref = `mailto:${email}?subject=${encodeURIComponent(mailtoSubject)}`;

  const copyAddress = async () => {
    if (!navigator.clipboard?.writeText) {
      setCopyState("error");
      setStatus("Copy is not available here. Select the address to copy it.");
      return;
    }

    try {
      await navigator.clipboard.writeText(email);
      setCopyState("copied");
      setStatus(`Copied ${email} to the clipboard.`);
    } catch {
      setCopyState("error");
      setStatus("The address could not be copied. Select it to copy it manually.");
    }
  };

  return (
    <div className="contact-actions">
      <a className="contact-email-link" href={mailtoHref}>
        <span>Email Johnny</span>
        <strong>{email}</strong>
      </a>
      <button
        type="button"
        className="contact-copy-button"
        aria-describedby={status ? statusId : undefined}
        onClick={copyAddress}
      >
        {copyState === "copied" ? "Address copied" : "Copy address"}
      </button>
      <p
        id={statusId}
        className={`contact-status ${copyState === "error" ? "is-error" : ""}`}
        role="status"
        aria-live="polite"
      >
        {status}
      </p>
    </div>
  );
}
